import { useIonToast } from '@ionic/react';
import { useCallback } from 'react';
import { tr } from '../i18n/translator';

/** Mensajes breves no bloqueantes. */
export function useToast() {
  const [present] = useIonToast();
  return useCallback(
    (message: string, tone: 'success' | 'danger' | 'dark' = 'dark') =>
      void present({ message: tr(message), duration: tone === 'danger' ? 4000 : 2200, position: 'top', color: tone === 'success' ? 'success' : tone === 'danger' ? 'danger' : 'dark' }),
    [present],
  );
}
